import { Header } from '@ytl/common-web';
import { useCallback, useMemo } from 'react';
import { useApp } from '../contexts/appContext';
import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';

export const LoginFrame = () => {
  const { language, setLanguage } = useLanguage();
  const { initParams } = useOpenAm();
  const { menuItems } = useApp();
  const onLanguageChange = useCallback(() => {
    if (language === 'hu') {
      setLanguage('en');
    } else {
      setLanguage('hu');
    }
  }, [language, setLanguage]);
  const realm = useMemo(() => {
    return initParams?.realm;
  }, [initParams]);

  return (
    <>
      <div className="frame__yui-header">
        <div className="frame__header">
          <Header
            mode={realm === 'b2b' ? 'b2b' : 'b2c'}
            menuItems={menuItems}
            language={language}
            onLanguageClick={onLanguageChange}
          ></Header>
        </div>
      </div>
    </>
  );
};
